module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_4-c188cbe5994095c2772fb8ecfd473e93.jpg";